import { render, staticRenderFns } from "./data-card.vue?vue&type=template&id=8093ddfc&scoped=true&"
import script from "./data-card.vue?vue&type=script&lang=js&"
export * from "./data-card.vue?vue&type=script&lang=js&"
import style0 from "./data-card.vue?vue&type=style&index=0&id=8093ddfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8093ddfc",
  null
  
)

export default component.exports